var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"bg_color"},[(!_vm.isAuthRoute)?_c('navbar'):_vm._e(),_c('div',{class:{ 'pa-3': !_vm.isAuthRoute }},[_c('router-view')],1),_c('notification')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }